import React from 'react';
import classNames from 'classnames';

import { COLLAPSIBLE_PANE_LAYOUT_PROP_TYPES } from './constants';

import styles from './CollapsiblePaneLayout.module.scss';

export class CollapsiblePaneLayout extends React.PureComponent {
  static propTypes = COLLAPSIBLE_PANE_LAYOUT_PROP_TYPES;

  render() {
    const { content, isPaneOpen, pane: paneContent } = this.props;

    const contentClasses = classNames(styles.content, {
      [styles.contentHasPane]: paneContent,
    });

    let pane = null;

    if (paneContent) {
      const paneClasses = classNames(styles.pane, {
        [styles.paneOpen]: isPaneOpen,
      });

      pane = (
        <div
          className={paneClasses}
          data-spec="eds-collapsible-pane-layout-pane"
        >
          {paneContent}
        </div>
      );
    }

    return (
      <div className={styles.root}>
        <div className={contentClasses}>{content}</div>
        {pane}
      </div>
    );
  }
}
